var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1142"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1142"
    },
    "bundlingPackage": "embedded-viral-link-ui",
    "bundlingPackageVersion": "static-1.6375",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};